
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiKayaking as ObiKayakingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-kayaking.js';
 
 
 

 
 export const ObiKayaking = createComponent({
   react: React,
   tagName: 'obi-kayaking',
   elementClass: ObiKayakingElement,
   events: {
     
   }
  });
 
 